module.exports = "<ng-container *ngIf=\"readonly;else ELSEBLOCK\">\n  <div [froalaView]=\"data\"></div>\n</ng-container>\n<ng-template #ELSEBLOCK>\n  <textarea [froalaEditor]=\"options\" (froalaModelChange)=\"onChange($event)\" [(froalaModel)]=\"data\" [disabled]=\"disabled\" >{{placeholder}}</textarea>\n</ng-template>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/nbinput/nbinput-froala.component.html
// module id = 190
// module chunks = 0 1